/**
 * Bridge from completed sessions to the progress repository.
 *
 * Kept as a thin, dependency-light module so screens can record results
 * without knowing about storage details. The full repository (versioned
 * localStorage, mastery, diagnostics) is implemented in the progress task; the
 * functions here are the stable call sites the engines use.
 */

import type { PracticeSession } from "../app/practice-session";
import type { QuizResults } from "../app/quiz-session";

// Populated by the repository module when it loads. Until then, recording is a
// safe no-op so practice/quiz work even before persistence is wired.
export interface ProgressRecorder {
  recordPractice(session: PracticeSession): void;
  recordQuiz(results: QuizResults): void;
}

let recorder: ProgressRecorder | null = null;

export function setProgressRecorder(r: ProgressRecorder): void {
  recorder = r;
}

/** The active recorder, if any (screens that need reads cast to the concrete type). */
export function getProgressRecorder(): ProgressRecorder | null {
  return recorder;
}

export function recordPracticeSummary(session: PracticeSession): void {
  recorder?.recordPractice(session);
}

export function recordQuizSummary(results: QuizResults): void {
  recorder?.recordQuiz(results);
}
